"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const KeyValue_1 = tslib_1.__importDefault(require("./KeyValue"));
class AnalysisSegment extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: 'f56702d8-9c2c-4998-b4ee-362ab0ea4e9c', description: 'The ID of this segment.' }),
    tslib_1.__metadata("design:type", String)
], AnalysisSegment.prototype, "segmentId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'rms_static_matches_offer_143111_', description: 'Name of the proposition' }),
    tslib_1.__metadata("design:type", String)
], AnalysisSegment.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Imported Static Leads from RMS', description: 'Description of the proposition' }),
    tslib_1.__metadata("design:type", String)
], AnalysisSegment.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => KeyValue_1.default),
    tslib_1.__metadata("design:type", Array)
], AnalysisSegment.prototype, "attributes", void 0);
exports.default = AnalysisSegment;
